import React from 'react'
import {floatToPercent} from './Utilitaire'

const FormatLine = ({ label, value, type, prefixe = '', suffixe = '' }) => (
    <p>{label} : <strong>{prefixe}{type === 'number' ? value.toLocaleString('fr') : value }{value === 0 ? '' : suffixe}</strong></p>
)

const RENDEMENT_FONDS_GARANTIS = 0.02465

const Hypothese = ({ situation, premier_versement, versement_libre, periodicite, prime_unique, cotisation, duree, rendement, frais }) => {
    
  const totalVstBrut = prime_unique === 'oui' ? versement_libre : cotisation * 12 * duree
  
  return (
    <div>
        <FormatLine
            label="Date de début de versements programmés"
            value={premier_versement} />
        <FormatLine
            label="Périodicité"
            value={prime_unique === 'oui' ? 'prime unique' : periodicite} />
        <FormatLine
            label="Durée des versements programmés"
            value={duree}
            suffixe=" ans"/>
        <FormatLine
            label="Total versements bruts"
            value={parseInt(totalVstBrut)} 
            type="number"
            suffixe=" CFA" />
        <FormatLine
            label="Frais"
            value={floatToPercent(frais)} />
        <FormatLine
            label="Rendement fonds garanti"
            value={floatToPercent(RENDEMENT_FONDS_GARANTIS, 3)} />
        <FormatLine
            label="Rendement UC"
            value={floatToPercent(rendement)} />
    </div>
  )
}

export default Hypothese


